<template>
  <div class="stance-tab">
    <div class="row">
      <div class="stance-details col-12" v-show="!showSpells">
        <div class="row">
          <div class="col-12 mb-4"><h3>{{weapon.name}}</h3></div>
        </div>

        <div class="row mb-4">
          <div class="col-12"><h5>Active Style: {{ucFirst(activeStance.combat_style)}}</h5>
          </div>
        </div>


        <div class="row">
          <div class="col-10 offset-1">
            <StanceSelector :stances="weapon.weapon.stances" :activeStance="activeStance" :activeSpell="activeSpell"
                            @selected="setStance" @stanceSpell="showSpellSelector"></StanceSelector>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <h5>Category: {{ucHuman(weapon.weapon.weapon_type)}}</h5>
          </div>
        </div>
      </div>

      <div class="spell-details col-12" v-show="showSpells">
        <div class="row">
          <div class="col-12">
            <SpellSelector @selected="spellSelected" @spellbookSwap="(sb) => {$emit('spellbookSwap', sb)}"
                           :spellbook="selectedSpellbook"></SpellSelector>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import StanceSelector from "../gear-selector/StanceSelector";
  import SpellSelector from "../gear-selector/SpellSelector";

  export default {
    name: "StanceTab",
    components: {SpellSelector, StanceSelector},
    props: {
      weapon: {
        type: Object,
        required: true,
      },
      activeSpell: {
        type: Object,
      },
      activeStance: {
        type: Object,
      },
      activeSpellbook: {
        type: String,
        default() {
          return 'standard'
        }
      }
    },
    data() {
      return {
        showSpells: false,
        spellbooks: {
          'standard': require('@/assets/data/spells/default.json'),
          'ancients': require('@/assets/data/spells/ancients.json'),
        }
      }
    },
    computed: {
      selectedSpellbook: function () {
        return this.spellbooks[this.activeSpellbook]
      }
    },
    methods: {
      setStance: function (stance) {
        this.$emit('stanceSelected', stance)
      },

      showSpellSelector: function () {
        this.showSpells = true;
      },

      spellSelected: function (spell) {
        this.$emit('spellSelected', spell);
        this.showSpells = false;
      },
    }
  }
</script>

<style scoped>
  span {
    font-family: 'RuneScape UF', sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/components/tabs/StanceTab.vue